import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Ошибка в компоненте:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
        return this.props.fallback || <div className='alert alert-danger'>Что-то пошло не так</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;